import Footer from 'components/Footer'
import React, { useEffect } from 'react'

const TermsOfUse = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Font Styles
    const headingFont = "'General Sans', sans-serif";
    const bodyFont = "'Manrope', sans-serif";

    const sectionTitleStyle = {
        marginTop: '40px',
        marginBottom: '15px',
        fontFamily: headingFont,
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#333',
        textTransform: 'uppercase'
    };

    const subSectionTitleStyle = {
        marginTop: '25px',
        marginBottom: '10px',
        fontFamily: headingFont,
        fontSize: '20px',
        fontWeight: '600',
        color: '#444'
    };

    const paragraphStyle = {
        textAlign: 'justify',
        marginTop: '10px',
        fontFamily: bodyFont,
        lineHeight: '1.8',
        color: '#555',
        fontSize: '16px'
    };

    const listStyle = {
        paddingLeft: '25px',
        paddingTop: '10px',
        fontFamily: bodyFont,
        color: '#555',
        lineHeight: '1.8',
        fontSize: '16px',
        listStyleType: 'disc'
    };

    const importantBox = {
        background: '#f4f5ff',
        borderLeft: '5px solid #747EEF',
        padding: '25px',
        marginTop: '30px',
        fontFamily: bodyFont,
        fontSize: '16px',
        color: '#333',
        fontWeight: '500'
    };

    return (
        <>
            <div style={{ width: '100%' }}>
                {/* Banner */}
                <div className="bannerImage" style={{ width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#747EEF' }}>
                    <h1 style={{ textAlign: 'center', fontSize: '50px', color: 'white', fontFamily: headingFont }}>Terms of Use</h1>
                </div>

                <div style={{ width: '85%', margin: 'auto', paddingBottom: '100px' }}>
                    <h2 style={{ marginTop: '50px', fontFamily: headingFont, fontSize: '36px' }}><strong>WASHTA TERMS OF USE</strong></h2>
                    <p style={paragraphStyle}>
                        <strong>Effective Date:</strong> March 17, 2026 | <strong>Last Updated:</strong> March 17, 2026 
                    </p>

                    <div style={importantBox}>
                        <p style={{fontFamily: headingFont, fontWeight: 'bold', marginBottom: '10px'}}>IMPORTANT NOTICE</p>
                        PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING THE WASHTA PLATFORM. BY ACCESSING OR USING THE PLATFORM, YOU AGREE TO BE LEGALLY BOUND BY THESE TERMS. IF YOU DO NOT AGREE TO THESE TERMS, YOU MUST NOT USE THE PLATFORM.
                        THESE TERMS CONTAIN IMPORTANT PROVISIONS INCLUDING LIABILITY LIMITATIONS, A DISCLAIMER OF WARRANTIES, AND EXCLUSIVE JURISDICTION PROVISIONS THAT AFFECT YOUR LEGAL RIGHTS.
                    </div>

                    {/* 1. DEFINITIONS */}
                    <h3 style={sectionTitleStyle}>1. DEFINITIONS AND INTERPRETATION</h3>
                    <h4 style={subSectionTitleStyle}>1.1 Definitions</h4>
                    <p style={paragraphStyle}>In these Terms, unless the context otherwise requires:</p>
                    <ul style={listStyle}>
                        <li>"Agreement" means these Terms of Use, together with the Privacy Policy and any other policies referenced herein.</li>
                        <li>"Booking" means a request submitted through the Platform to reserve a Service from a Service Provider.</li>
                        <li>"Customer" or "you" means any individual or entity that accesses or uses the Platform.</li>
                        <li>"Fees" means the charges payable for Services as displayed on the Platform, plus any applicable taxes and service charges.</li>
                        <li>"Platform" means the Washta mobile application, website, and all related digital services and infrastructure.</li>
                        <li>"Service Provider" means an independent third-party business or individual that offers car care Services through the Platform.</li>
                        <li>"Services" means car wash, detailing, maintenance, or other automotive care services provided by Service Providers.</li>
                        <li>"Washta" or "we" or "us" means SNR LLC, a limited liability company registered in the United Arab Emirates, Sharjah Media City, Sharjah, UAE (Commercial License No. 2429317.01).</li>
                    </ul>
                    <h4 style={subSectionTitleStyle}>1.2 Interpretation</h4>
                    <ul style={listStyle}>
                        <li>Headings are for convenience only and do not affect interpretation.</li>
                        <li>Words in the singular include the plural and vice versa.</li>
                        <li>References to "includes" or "including" are without limitation.</li>
                        <li>References to statutory provisions include those provisions as amended or re-enacted.</li>
                    </ul>

                    {/* 2. ACCEPTANCE */}
                    <h3 style={sectionTitleStyle}>2. ACCEPTANCE AND SCOPE</h3>
                    <h4 style={subSectionTitleStyle}>2.1 Binding Agreement</h4>
                    <p style={paragraphStyle}>By creating an account, accessing the Platform, or booking a Service, you agree to be legally bound by these Terms and our Privacy Policy. If you do not agree, you must immediately cease using the Platform.</p>
                    <h4 style={subSectionTitleStyle}>2.2 Capacity and Authority</h4>
                    <p style={paragraphStyle}>You represent and warrant that: You are at least 18 years of age; You have the legal capacity to enter into binding contracts under UAE law; If acting on behalf of a business entity, you have authority to bind that entity; You are not prohibited from using the Platform under any applicable law.</p>
                    <h4 style={subSectionTitleStyle}>2.3 Use by Minors</h4>
                    <p style={paragraphStyle}>The Platform is not intended for individuals under 18. If you are between 15 and 17, you may only use the Platform with express consent and supervision of a parent or legal guardian.</p>
                    <h4 style={subSectionTitleStyle}>2.4 Geographic Scope</h4>
                    <p style={paragraphStyle}>The Platform is intended for use within the United Arab Emirates. Access from other jurisdictions is at your own risk.</p>

                    {/* 3. NATURE OF PLATFORM */}
                    <h3 style={sectionTitleStyle}>3. NATURE OF THE PLATFORM AND WASHTA'S ROLE</h3>
                    <h4 style={subSectionTitleStyle}>3.1 Digital Marketplace Aggregator</h4>
                    <p style={paragraphStyle}>Washta operates as a digital marketplace aggregator and technology platform. We connect Customers with independent Service Providers but do NOT provide car care Services ourselves.</p>
                    <h4 style={subSectionTitleStyle}>3.2 What Washta Does</h4>
                    <p style={paragraphStyle}>Washta's role is limited to providing technology infrastructure, processing payments on behalf of Service Providers, facilitating communication, and providing customer support for Platform-related issues.</p>
                    <h4 style={subSectionTitleStyle}>3.3 What Washta Does NOT Do</h4>
                    <p style={paragraphStyle}>Washta does NOT: Own or manage facilities; Employ or control Service Providers; Perform actual Services; Enter into service contracts with Customers (contract is with the Service Provider); Guarantee quality or safety; Or insure vehicles.</p>
                    <h4 style={subSectionTitleStyle}>3.4 Independent Contractor Relationship</h4>
                    <p style={paragraphStyle}>Service Providers are independent contractors responsible for their own operations, employees, equipment, and compliance with laws.</p>
                    <h4 style={subSectionTitleStyle}>3.5 Tripartite Relationship</h4>
                    <p style={paragraphStyle}>Three relationships are created: Customer-Washta (Terms of Use); Customer-Service Provider (Service Contract); and Washta-Service Provider (Commercial Agreement). Washta is not a party to the contract between you and the Service Provider.</p>

                    {/* 4. USER ACCOUNTS */}
                    <h3 style={sectionTitleStyle}>4. USER ACCOUNTS AND REGISTRATION</h3>
                    <h4 style={subSectionTitleStyle}>4.1 Account Creation</h4>
                    <p style={paragraphStyle}>You must provide: Full name, valid email, mobile number, password, vehicle information, payment details, and location data.</p>
                    <h4 style={subSectionTitleStyle}>4.2 Account Accuracy</h4>
                    <p style={paragraphStyle}>You warrant that all information provided is accurate and you will update it promptly.</p>
                    <h4 style={subSectionTitleStyle}>4.3 Account Security</h4>
                    <p style={paragraphStyle}>You are responsible for maintaining credential confidentiality and all activities under your account.</p>

                    {/* 5. BOOKING SERVICES */}
                    <h3 style={sectionTitleStyle}>5. BOOKING SERVICES</h3>
                    <h4 style={subSectionTitleStyle}>5.1 Booking Process</h4>
                    <p style={paragraphStyle}>A booking is confirmed when a Service Provider accepts your request. You will receive confirmation via email/SMS.</p>
                    <h4 style={subSectionTitleStyle}>5.2 Binding Contract</h4>
                    <p style={paragraphStyle}>A binding service contract is formed between you and the Service Provider upon their acceptance.</p>

                    {/* 6. FEES & PAYMENT */}
                    <h3 style={sectionTitleStyle}>6. FEES, PAYMENT, AND PRICING</h3>
                    <h4 style={subSectionTitleStyle}>6.1 Payment Processing</h4>
                    <p style={paragraphStyle}>Payments are handled by Stripe. You authorize Washta to charge the applicable Fees.</p>
                    <h4 style={subSectionTitleStyle}>6.2 Fee Components</h4>
                    <p style={paragraphStyle}>Total Fee includes: Service Fee, Platform Service Charge, Taxes (VAT), and any disclosed Additional Charges.</p>
                    <h4 style={subSectionTitleStyle}>6.8 Payment Security</h4>
                    <p style={paragraphStyle}>We use PCI DSS-compliant processors. We do NOT store full credit/debit card numbers or CVV codes.</p>

                    {/* 7. CANCELLATIONS */}
                    <h3 style={sectionTitleStyle}>7. CANCELLATIONS, MODIFICATIONS, AND REFUNDS</h3>
                    <h4 style={subSectionTitleStyle}>7.1 Customer-Initiated Cancellations</h4>
                    <p style={paragraphStyle}>Cancellations more than 24 hours before: Eligible for full refund (minus fees). Less than 24 hours: Subject to cancellation fee up to 50%.</p>
                    <h4 style={subSectionTitleStyle}>7.2 Service Provider-Initiated</h4>
                    <p style={paragraphStyle}>If the provider cancels, you receive a full refund of all Fees paid.</p>

                    {/* 8. LIABILITY */}
                    <h3 style={sectionTitleStyle}>8. SERVICE PERFORMANCE, QUALITY, AND LIABILITY</h3>
                    <h4 style={subSectionTitleStyle}>8.1 Service Provider Sole Responsibility</h4>
                    <p style={paragraphStyle}>The Service Provider is exclusively responsible for quality, safety, legality, equipment, and insurance of Services.</p>
                    <h4 style={subSectionTitleStyle}>8.2 Washta's Disclaimer of Liability</h4>
                    <p style={{...paragraphStyle, color: '#d9534f', fontWeight: 'bold'}}>TO THE FULLEST EXTENT PERMITTED BY UAE LAW, WASHTA DISCLAIMS ALL LIABILITY FOR VEHICLE DAMAGE, THEFT, PERSONAL INJURY, OR SERVICE DEFECTS CAUSED BY SERVICE PROVIDERS.</p>

                    {/* 9. USER CONDUCT */}
                    <h3 style={sectionTitleStyle}>9. USER CONDUCT AND ACCEPTABLE USE</h3>
                    <h4 style={subSectionTitleStyle}>9.1 Prohibited Conduct</h4>
                    <p style={paragraphStyle}>You agree NOT to: Use for illegal purposes; upload viruses; scrape data; post defamatory reviews; or contact providers outside the platform to circumvent fees.</p>

                    {/* 10. TERMINATION */}
                    <h3 style={sectionTitleStyle}>10. ACCOUNT SUSPENSION AND TERMINATION</h3>
                    <p style={paragraphStyle}>Washta may terminate your account immediately if you violate these Terms or engage in fraudulent conduct.</p>

                    {/* 13. INTELLECTUAL PROPERTY */}
                    <h3 style={sectionTitleStyle}>13. INTELLECTUAL PROPERTY RIGHTS</h3>
                    <p style={paragraphStyle}>All software, logos (including "Washta"), and content are owned by SNR LLC and protected by UAE laws.</p>

                    {/* 15. LIMITATION OF LIABILITY */}
                    <h3 style={sectionTitleStyle}>15. LIMITATION OF LIABILITY</h3>
                    <h4 style={subSectionTitleStyle}>15.3 Liability Cap</h4>
                    <p style={paragraphStyle}>IN NO EVENT SHALL WASHTA’S TOTAL AGGREGATE LIABILITY EXCEED THE LESSER OF: (a) TOTAL FEES PAID IN THE LAST 12 MONTHS; OR (b) AED 1,000.</p>

                    {/* 17. GOVERNING LAW */}
                    <h3 style={sectionTitleStyle}>17. GOVERNING LAW AND JURISDICTION</h3>
                    <p style={paragraphStyle}>These Terms are governed by the Federal Laws of the United Arab Emirates. Exclusive jurisdiction belongs to the courts of Dubai.</p>

                    {/* 18. DISPUTE RESOLUTION */}
                    <h3 style={sectionTitleStyle}>18. DISPUTE RESOLUTION</h3>
                    <p style={paragraphStyle}>Before litigation, you agree to attempt informal resolution by contacting info@washta.com. If that fails, disputes will be resolved individually in Dubai Courts. Any claim must be filed within one (1) year.</p>

                    {/* 20. CONTACT */}
                    <h3 style={sectionTitleStyle}>20. CONTACT INFORMATION</h3>
                    <p style={paragraphStyle}>
                        <strong>SNR LLC</strong> <br />
                        Sharjah Media City, Sharjah, UAE <br />
                        Commercial License No.: 2429317.01 <br />
                        <strong>Email:</strong> info@washta.com <br />
                        <strong>Phone:</strong> +971 50 9717288
                    </p>

                    <div style={{ textAlign: 'center', marginTop: '60px', borderTop: '1px solid #ddd', paddingTop: '30px' }}>
                        <p style={{ ...paragraphStyle, textAlign: 'center', fontWeight: 'bold' }}>
                            ACKNOWLEDGMENT: BY USING THE WASHTA PLATFORM, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS OF USE.
                        </p>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default TermsOfUse;